import { render, staticRenderFns } from "./formStep2.vue?vue&type=template&id=6c2ba812&scoped=true&"
import script from "./formStep2.vue?vue&type=script&lang=js&"
export * from "./formStep2.vue?vue&type=script&lang=js&"
import style0 from "./formStep2.vue?vue&type=style&index=0&id=6c2ba812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2ba812",
  null
  
)

export default component.exports